<template>
  <div class="footer-item">
    <el-row class="footer-div">
      <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="6">
        <div class="grid-content theme_font_color">
          关于我们
          <p>
            <span
              @click="
                hanldClick(
                  'https://moshouapphelp.zendesk.com/hc/zh-cn/articles/1500000511822'
                )
              "
              class="hover-text"
              >隐私政策</span
            >
          </p>
          <p>
            <span
              @click="
                hanldClick(
                  'https://moshouapphelp.zendesk.com/hc/zh-cn/articles/360058987734'
                )
              "
              class="hover-text"
              >服务协议</span
            >
          </p>
        </div>
      </el-col>
      <el-col :xs="16" :sm="8" :md="8" :lg="6" :xl="6">
        <div class="grid-content theme_font_color">
          联系方式
          <p>
            微博：
            <span
              class="hover-text"
              @click="hanldClick('https://weibo.com/u/2108747913')"
              >@墨__守</span
            >
          </p>
          <p>
            邮箱：
            <a class="hover-text" href="mailto:support@moshouapp.com"
              >support@moshouapp.com</a
            >
            <!-- <span class="hover-text" @click="hanldClick('https://weibo.com/u/2108747913')">support@moshouapp.com</span>
            </p> -->
          </p>
        </div>
      </el-col>
      <!-- <el-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4">
        <div class="grid-content theme_font_color">价格</div>
      </el-col>-->
      <el-col :xs="18" :sm="8" :md="8" :lg="6" :xl="6">
        <div class="grid-content theme_font_color">
          博客
          <p class="hover-text" @click="hanldClick('https://www.moshou.me')">
            https://www.moshou.me
          </p>
        </div>
      </el-col>
      <el-col class="icp" :span="24">
        <a href="http://beian.miit.gov.cn/" target="_blank"
          >陕ICP备2021008445号-1</a
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "item",
  data() {
    return {};
  },
  methods: {
    hanldClick(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style scoped lang="less">
.footer-item {
  height: 160px !important;
  width: 100%;
  // position: absolute;
  // bottom: 0;
  .footer-div {
    margin: 32px 0 0;
  }
  .grid-content {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    p {
      font-size: 14px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: #666666;
      margin-top: 18px;
    }
  }
  .icp {
    color: #666666;
    text-align: center;
    margin: 40px 0px 20px;
  }
  .hover-text {
    cursor: pointer;
    color: #666666;
  }
  .hover-text:hover {
    color: rgba(255, 204, 0, 1);
  }
}
</style>